import BaseComponent from './basecomponent';
import 'jquery';
import 'swiper';

export default class Slider extends BaseComponent {
    static get DEFAULTS() {
        return {
            autoresize: {                           // Opzioni di autoridimensionamento dello slider
                enabled: false,                     // Abilitato o no (bool)
                heightRatio: 0.5,                   // Rapporto altezza slider rispetto altezza pagina (float da 0 a 1)
                enabledScrolled: false,             // Abilitato o no allo scroll della pagina (bool)
                heightRatioScrolled: 0.3            // Rapporto altezza slider rispetto altezza pagina quando la pagina è scrollata (float da 0 a 1)
            },
            captions: {                             // Opzioni captions
                enabled: false                      // Abilitati o no (bool)
            },
            thumbsSlider: {                         // Opzioni slider thumbs
                enabled: false,                     // Abilitato o no (bool)
                containerId: null,                  // Id del contenitore dello slider thumbs
                options: {}                         // Opzioni Swiper per il thumbs slider: http://idangero.us/swiper/api/
            }
        }
    }

    /** Opzioni default Swiper: http://idangero.us/swiper/api/ */
    static get SWIPER_DEFAULTS() {
        return {
            direction: 'horizontal',
            pagination: '.swiper-pagination',
            paginationClickable: true,
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
            loop: true,
            effect: 'slide',
            autoplay: 5000,
            speed: 1000
        }
    }

    /**
     * Costruisce l'oggetto slider con le opzioni di configurazione indicate
     * @param containerId Id dell'elemento container della mappa. es. 'topSlider'
     * @param options Opzioni di configurazione dello slider, vedi Slider.DEFAULTS per tutte le opzioni a disposizione
     * @param swiperOptions Opzioni di configurazione di Swiper, vedi Slider.SWIPER_DEFAULTS per tutte le opzioni predefinite
     */
    constructor(containerId, options, swiperOptions) {
        super();

        this.slider = null;
        this.containerId = containerId;
        this.options = $.extend(true, {}, Slider.DEFAULTS, options);
        this.swiperOptions = $.extend(true, {}, Slider.SWIPER_DEFAULTS, swiperOptions);
    }

    /**
     * Renderizza lo slider, da chiamare manualmente quando il DOM è pronto
     */
    render() {
        this.sliderContainer = document.getElementById(this.containerId);
        this.slider = new Swiper(this.sliderContainer, this.swiperOptions);

        if (this.numberOfSlides() <= 1) {
            // Una sola slide presente, disabilito autoplay
            this.slider.stopAutoplay();
            this.slider.lockSwipes();
            this.slider.paginationContainer.addClass('hidden');
        }

        if (this.options.captions.enabled) {
            this._initCaptions();
        }

        if (this.options.autoresize.enabled) {
            this._initAutoresize();
        }

        if (this.options.thumbsSlider.enabled) {
            this._initThumbsSlider();
        }
    }

    numberOfSlides() {
        if (!this.slider || !this.slider.slides) return 0;
        return this.slider.slides.not('.' + this.slider.params.slideDuplicateClass).length;
    }

    /**
     * Inizializza le captions delle slide
     * @private
     */
    _initCaptions() {
        var onSlideChangeStartCallback = function (swiper) {
            var $captionContainer = swiper.container.find('.slider-caption-container > .slider-caption-wrapper'),
                $currentSlide = swiper.container.find('.swiper-slide-active');

            var $oldCaption = $captionContainer.find('> .slide-caption'),
                $clonedCaption = $currentSlide.find('.slide-caption').clone(),
                animationSpeed = swiper.params.speed / 2.0;

            if ($oldCaption.length > 0) {
                $clonedCaption.css('display', 'none');
            }

            $captionContainer.append($clonedCaption);
            $oldCaption.fadeOut(animationSpeed, function () {
                $(this).remove();
                $clonedCaption.fadeIn(animationSpeed);
            });
        };

        onSlideChangeStartCallback(this.slider);
        this.slider.on('slideChangeStart', onSlideChangeStartCallback);
    }

    /**
     * inizializza l'autoresize dello slider
     * @private
     */
    _initAutoresize() {
        var $window = $(window),
            $slider = $(this.sliderContainer),
            heightRatio = this.options.autoresize.heightRatio,
            heightRatioScroll = this.options.autoresize.heightRatioScrolled,
            onScrollEnabled = this.options.autoresize.enabledScrolled;

        // Event callback
        var autoresizeCallback = function () {
            var windowHeight = $window.outerHeight(),
                scrollY = $window.scrollTop(),
                ratio = heightRatio;

            if (onScrollEnabled && scrollY > 100) {
                ratio = heightRatioScroll;
            }

            var height = windowHeight * ratio;

            $slider.css('height', height);
        };

        // Set events callback
        autoresizeCallback = (typeof $.throttle === 'function') ? $.throttle(250, autoresizeCallback) : autoresizeCallback;
        $window.resize(autoresizeCallback).trigger('resize');
        if (onScrollEnabled) {
            // Modifico l'altezza dello slider allo scroll
            $window.scroll(autoresizeCallback);
        }
    }

    /**
     * Inizializza lo slider delle thumbs
     * @private
     */
    _initThumbsSlider() {
        this.thumbsSlider = new Slider.ThumbsSlider(this.options.thumbsSlider.containerId, this.slider, this.options.thumbsSlider.options);
        this.thumbsSlider.render();
    }
}

Slider.ThumbsSlider = class ThumbsSlider extends BaseComponent {
    /** Opzioni default Swiper: http://idangero.us/swiper/api/ */
    static get SWIPER_DEFAULTS() {
        return {
            direction: 'horizontal',
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
            spaceBetween: 10,
            slidesPerView: 'auto',
            centeredSlides: true
        }
    }

    /**
     * Costruisce l'oggetto ThumbsSlider con le opzioni indicate.
     * Il ThumbsSlider controllerà anche il cambio slide nello slider genitore al click su una thumb.
     *
     * @param containerId Id dell'elemento container della mappa. es. 'thumbsSlider'
     * @param parentSlider Slider genitore che si vuole controllare con questo thumbs slider
     * @param swiperOptions Opzioni di configurazione di Swiper, vedi ThumbsSlider.SWIPER_DEFAULTS per tutte le opzioni predefinite
     */
    constructor(containerId, parentSlider, swiperOptions) {
        super();

        this.containerId = containerId;
        this.sliderContainer = null;
        this.slider = null;
        this.parentSlider = parentSlider;
        this.swiperOptions = $.extend(true, {}, ThumbsSlider.SWIPER_DEFAULTS, swiperOptions);
    }

    /**
     * Renderizza lo slider delle thumbs
     */
    render() {
        this.sliderContainer = document.getElementById(this.containerId);
        this.slider = new Swiper(this.sliderContainer, this.swiperOptions);
        if (!this.sliderContainer || ! this.slider) {
            console.error('Impossibile inizializzare lo slider delle thumbs')
            return;
        }

        var topSwiper = this.parentSlider,
            thumbsSwiper = this.slider;

        $(this.sliderContainer).find('.swiper-thumb').click(function(e) {
            var slideIndex = $(this).parent().data('slide-index');
            topSwiper.slideTo(slideIndex);
            thumbsSwiper.slideTo(slideIndex - 1);
        });

        thumbsSwiper.on('slideChangeStart', function(swiper) {
            topSwiper.slideTo(swiper.activeIndex + 1);
        });
    }
};


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/slider.js
 **/